export const GET_LEASEFORMS = "GET_LEASEFORMS";
export const ADD_UNITS_VISIBLE = "ADD_UNITS_VISIBLE"
export const SET_LEAD_ID = 'SET_LEAD_ID'
export const GET_CURRENT_PAGE = 'GET_CURRENT_PAGE'